import React from 'react';
import PropTypes from 'prop-types';
import './answer.css';

const Answer = props => {
  const { answerText, onChangeAnswer, value, multi, groupName } = props;

  return (
    <label className="answer">
      {answerText}
      <input
        type={multi ? 'checkbox' : 'radio'}
        name="answer"
        className="answer__input"
        value={value}
        onChange={(e) => onChangeAnswer(e, groupName)}
      />
    </label>
  );
};

Answer.propTypes = {
  answerText: PropTypes.string.isRequired,
  onChangeAnswer: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired
};

export default Answer;
